// language=GraphQL
export const ALL_TIERS_QUERY = `query Query {
  tiers: bargainTiers {
    id
    fromPrice
    discount
  }
}`

// language=GraphQL
export const SINGLE_TIER_QUERY = `query Query($id: ID!) {
  tier: bargainTier(id: $id) {
    id
    fromPrice
    discount
  }
}`

// language=GraphQL
export const CREATE_TIER_MUTATION = `
  mutation Mutation($input: CreateBargainTierInput) {
    tier: createBargainTier(input: $input) {
      id
      fromPrice
      discount
    }
  }`

// language=GraphQL
export const UPDATE_TIER_MUTATION = `
  mutation Mutation($input: UpdateBargainTierInput) {
    tier: updateBargainTier(input: $input) {
      id
      fromPrice
      discount
    }
  }`

// language=GraphQL
export const DELETE_TIER_MUTATION = `
  mutation Mutation($input: DeleteBargainTierInput) {
    deleteBargainTier(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TIER_MUTATION = `
  mutation Mutation($input: DeleteBargainTierInput) {
    forceDeleteBargainTier(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TIERS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelBargainSettings: Boolean = false, $withRatioBargainConfigs: Boolean = false) {
  groupedDependents: bargainTierDependents(id: $id) {
    travelBargainSettings @include(if: $withTravelBargainSettings) {
      id
      active
      untilDaysBeforeStart
    }
    ratioBargainConfigs @include(if: $withRatioBargainConfigs) {
      id
      active
      priceCap
      serviceCodePrefix    }
  }
}`
